module.exports = __webpack_public_path__ + "static/media/carta_19.b923cecf.jpg";